import { createSlice } from '@reduxjs/toolkit';
import { getCustomFormsThunk } from './thunks/customFormsThunks';
import { saveInputImageToS3Thunk } from './thunks/filledCustomFormsThunks';

export const customFormsSlice = createSlice({
  name: 'customForms',
  initialState: {
    forms: [],
    selectedForm: null,
    isLoading: false,
    error: null,
  },

  reducers: {
    setForms: (state, action) => {
      state.forms = action.payload;
    },
    setSelectedForm: (state, action) => {
      state.selectedForm = action.payload;
    },
  },

  extraReducers(builder) {
    builder
      .addCase(getCustomFormsThunk.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getCustomFormsThunk.fulfilled, (state, action) => {
        const customForms = action.payload;
        state.forms = customForms;
        state.isLoading = false;
        state.error = null;
      })
      .addCase(getCustomFormsThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(saveInputImageToS3Thunk.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(saveInputImageToS3Thunk.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(saveInputImageToS3Thunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export const { setForms, getForms, setSelectedForm } = customFormsSlice.actions;

// Selectors
export const selectAllCustomForms = (state) => state.customFormsSlice?.forms;

export const selectFormsLoading = (state) => state.customFormsSlice?.isLoading;
export const selectFormsError = (state) => state.customFormsSlice?.error;
export const selectSelectedForm = (state) => {
  const selectedForm = state.customFormsSlice.selectedForm;
  const inputFieldArray = Object.values(selectedForm?.inputFields || []);
  const sortedInputFields = [...inputFieldArray].sort((a, b) => {
    return (a.originalIndex || 999) - (b.originalIndex || 999);
  });
  return {
    ...selectedForm,
    inputFields: sortedInputFields,
  };
};
